<template>
    <div class="h-100">
    <form @submit="checkForm" action="" method="post" novalidate="true" class="h-100">
      <div class="form-section first-section h-100 pb-25" id="modalConfirmRegister">
      <div class="form-field">
        <div class="xs-flex xs-items-center xs-mb-5">
          <label class="label label-input xs-mb-0" for="FirstName">{{$t('first_name')}}<span class="cl-red">{{ $t('required') }}</span></label>
          <span v-if="errors.firstName" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
                                        <span>{{ errors.firstName }}</span><i class="icon-error"></i>
              </span>
        </div>
        <input id="FirstName" ref="firstName" class="input xs-mb-10  "
               v-bind:class="{ 'has-errors': errors.firstName , 'has-success': errors.firstName === false}"
               name="firstName" v-model="firstName" value="" v-bind:placeholder="$t('place_holder_first_name')"
               type="text">
      </div>
      <div class="form-field">
        <div class="xs-flex xs-items-center xs-mb-5">
          <label class="label label-input xs-mb-0" for="LastName">{{$t('last_name')}}<span class="cl-red">{{ $t('required') }}</span></label>
          <span v-if="errors.lastName" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
                                        <span>{{ errors.lastName }}</span><i class="icon-error"></i>
              </span>
        </div>
        <input id="LastName" ref="lastName" class="input xs-mb-10  "
               v-bind:class="{ 'has-errors': errors.lastName , 'has-success': errors.lastName === false}"
               name="lastName" v-model="lastName" value="" v-bind:placeholder="$t('place_holder_last_name')"
               type="text">
      </div>
    <div class="form-field">
      <div class="xs-flex xs-items-center xs-mb-5">
        <label class="label label-input xs-mb-0" for="emailAddress">{{$t('email')}}<span class="cl-red">{{ $t('required') }}</span></label>
        <span v-if="errors.emailAddress" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
                                        <span>{{ errors.emailAddress }}</span><i class="icon-error"></i>
              </span>
      </div>
      <input disabled="true" id="emailAddress" ref="emailAddress"
             v-bind:class="{ 'has-errors': errors.emailAddress , 'has-success': errors.emailAddress === false }"
             name="emailAddress" v-model="emailAddress" class="input xs-mb-10" value="" type="text"
             v-bind:placeholder="$t('place_holder_email')">
    </div>

    <div class="form-field">
      <div class="row">
        <div class="col-sm-3 col-xs-3">
          <div class="xs-flex xs-items-center xs-mb-5">
            <label class="label label-input xs-mb-0" for="phone">{{$t('prefix_phone_register')}}</label>
          </div>
        </div>
        <div class="pl-5 col-sm-9 col-xs-9">
          <div class="xs-flex xs-items-center xs-mb-5">
            <label class="label label-input xs-mb-0" for="phone">{{$t('phone_number')}}<span class="cl-red">{{ $t('required') }}</span></label>
            <span v-if="errors.phone" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
                                      <span>{{ errors.phone }}</span><i class="icon-error"></i>
                </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 col-xs-3">
          <select v-model="prefix" class="form-control " ref="prefix-phone">
            <option v-for="pre in prefix_form" v-bind:value="pre.value">
              {{ pre.name }}
            </option>
          </select>
        </div>
        <div class="pl-5 col-sm-9 col-xs-9">
          <input type="text" id="phone" ref="phone" class="input xs-mb-10 "
                 v-bind:minlength="$const.PHONE_MIN_LENGTH"
                 v-bind:maxlength="$const.PHONE_MAX_LENGTH"
                 v-bind:class="{ 'has-errors': errors.phone, 'has-success': errors.phone === false }"
                 name="phone"
                 v-model="phone"
                 v-bind:placeholder="$t('place_holder_phone')">
        </div>
      </div>
    </div>

    <div class="form-field">
      <div class="xs-flex xs-items-center xs-mb-5">
        <label class="label label-input xs-mb-0">{{$t('profile.register_news')}}</label>
      </div>
      <label class="xs-mb-30 xs-block pl-15">
        <input v-model="receive_notification" class="checkbox" type="checkbox">
        <span>{{$t('profile.register_news_content')}}</span>
      </label>
    </div>
    <div v-show="receive_notification" class="form-field pl-15">
      <div class="xs-flex xs-items-center xs-mb-5">
        <label class="label label-input xs-mb-0">{{$t('pizza_preference')}}</label>
      </div>
      <label class="xs-mb-30 xs-block">
        <div class="xs-mt-20">
          <div class="pizza-preference-option" v-for="value in pizza_preferences" style="">
            <label class="xs-items-center xs-px-10 rounded label-radio"
                   :for="`pizza-preference-modal-`+value">
              <input class="xs-block rounded xs-p-5 radio PizzaPreference"
                     :id="`pizza-preference-modal-`+value" name="PizzaPreference"
                     :value="value"
                     v-model="pizza_preference" type="radio"
              >
              <i class="pull-left"></i>
              <span class="xs-mr-auto typo-l5 xs-items-center">
                      <i class="xs-hide md-block xs-mr-10"></i>
                      <span class="fw400 text-black t15">{{value}}</span>
                    </span>
            </label>
          </div>
          <div class="xs-mb-10"></div>
        </div>
      </label>
    </div>

    <div v-if="false" class="form-field">
      <div class="xs-flex xs-items-center xs-mb-5">
        <label class="label label-input xs-mb-0">{{$t('profile.register_html')}}</label>
      </div>
      <label class="xs-mb-30 xs-block">
        <input v-model="receive_html_mail" class="checkbox" type="checkbox">
        <span>{{$t('profile.register_html_content')}}</span>
      </label>
    </div>

    <!--BIRTHDAY-->
    <div class="birthday-section" >
      <div v-show="receive_notification" class="form-field ">
        <div class="xs-flex xs-items-center xs-mb-5">
          <label class="label label-input xs-mb-0">{{$t('birth_day')}}<span
            class="cl-red">{{ $t('required') }}</span></label>
          <span v-if="errors.birthday" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
                                        <span>{{ errors.birthday }}</span>
              </span>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <select v-model="birthday.day" class="form-control " ref="birthdayDay">
              <option disabled value="">{{$t('day')}}</option>
              <option v-for="item in 31" v-bind:value="item">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <select v-model="birthday.month" class="form-control " ref="birthdayMonth">
              <option disabled value="">{{$t('month')}}</option>
              <option v-for="item in 12" v-bind:value="item">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <select v-model="birthday.year" class="form-control " ref="birthdayYear">
              <option disabled value="">{{$t('year')}}</option>
              <option v-for="item in (new Date()).getFullYear() " v-if="item >= $const.LIMIT_BIRTHDAY"
                      v-bind:value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!--END BIRTHDAY-->

    <div class="form-field pt-10 terms">
      <div class="row">
        <div class="col-sm-12 xs-flex xs-items-center xs-mb-5">
                <span v-if="errors.term" class="xs-text-right typo-l7 xs-text-red xs-ml-auto error-text">
                                        <span>{{ errors.term }}</span>
                </span>
        </div>
        <div class="col-sm-12 term-box">
          <label class="xs-mb-30 col-sm-1 xs-block checkbox-box" for="marketing_modal">
            <input name="term" ref="term" v-model="term" id="marketing_modal" class="checkbox" type="checkbox">
            <span class="xs-flex xs-items-center fw-normal text-black ">
                                        </span>
          </label>
          <span class="col-sm-11 fw-normal text-black ">
                                         {{$t('term_1')}} <a class="underline" href="/terms">{{$t('term_4')}}</a> & <a
            class="underline" href="/privacy">{{$t('term_2')}}</a> {{$t('term_3')}}
                                    </span>
        </div>
      </div>
    </div>
    <input type="submit" class="button button--primary" :value="$t('register')">

  </div>
    </form>
    </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['params'],
    data(){
      return {
        term: '',
        firstName: this.params.first_name,
        lastName: this.params.last_name,
        emailAddress: this.params.email,
        phone: '',
        errors: {
          'birthday': '',
          'birthday_month': '',
          'birthday_day': '',
          'emailAddress': '',
          'phone': '',
          'firstName': '',
          're_password': '',
          'password': '',
          'lastName': '',
          'localFirstName': '',
          'localLastName': '',
        },
        birthday: {
          year: '',
          month: '',
          day: ''
        },
        receive_notification: 0,
        pizza_preference: this.$t('pizza_preference.all'),
        pizza_preferences: [
          this.$t('pizza_preference.all'),
          this.$t('pizza_preference.meat'),
          this.$t('pizza_preference.vegetarian'),
          this.$t('pizza_preference.vegan'),
        ],
        prefix : this.$const.DEFAULT_PREFIX_PHONE,
        prefix_form : this.$const.PREFIX_PHONE
      }
    },
    watch: {
      emailAddress: function (newValue, oldValue) {
        if (!this.emailAddress) {
          this.errors.emailAddress = this.$t('required_display')
        } else if (!this.validEmail(this.emailAddress)) {
          this.errors.emailAddress = this.$t('validate_invalid_email')
        } else {
          this.errors.emailAddress = false
        }
      },
      firstName: function (newValue, oldValue) {
        if (!this.firstName) {
          this.errors.firstName = this.$t('required_display')
        } else {
          this.errors.firstName = false
        }

        if (this.$i18n.locale == this.$const.LANG_EN) {
          this.localFirstName = newValue;
        }
      },
      lastName: function (newValue, oldValue) {
        if (!this.lastName) {
          this.errors.lastName = this.$t('required_display')
        } else {
          this.errors.lastName = false
        }

        if (this.$i18n.locale == this.$const.LANG_EN) {
          this.localLastName = newValue;
        }
      },
      phone: function (newValue, oldValue) {
        let numbers = /^[0-9]+$/;
        let message = '';
        if (newValue && !newValue.match(numbers)) {
          message = this.$t('input_phone_reminder');
        } else if (!this.phone) {
          message = this.$t('required_display');
        } else if (this.phone.length < this.$const.PHONE_MIN_LENGTH || this.phone.length > this.$const.PHONE_MAX_LENGTH) {
          message = this.$t('validate_invalid_phone');
        } else if (this.checkPhoneValid(this.phone)) {
          message = this.$t('validate_invalid_phone_number');
        } else {
          message = false
        }

        this.errors.phone = message;
      },
      term: function (newValue, oldValue) {
        this.errors.term = ''
        if (!this.term) {
          this.errors.term = this.$t('validate_term')
        }
      }
    },
    methods: {
      checkPhoneValid: function (phone) {
        let phoneValid = true
        for (let i = 0; i < phone.length; i++) {
          if (phone[i] !== '0') {
            phoneValid = false
            break
          }
        }
        return phoneValid
      },

      checkForm: function (e) {
        e.preventDefault()
        let flag = false

        this.errors = {
          'birthday': '',
          'emailAddress': '',
          'phone': '',
          'firstName': '',
          'lastName': '',
          're_password': '',
          'password': '',
          'localFirstName': '',
          'localLastName': '',
          'birthday_month': '',
          'birthday_day': ''
        }

        if (!this.firstName) {
          this.errors.firstName = this.$t('required_display')

          this.$refs.firstName.focus()
          flag = true
        } else {
          this.errors.firstName = false
        }

        if (!this.lastName) {
          this.errors.lastName = this.$t('required_display')
          if (!flag) {
            this.$refs.lastName.focus()
          }
          flag = true
        } else {
          this.errors.lastName = false
        }

        if (this.$i18n.locale == this.$const.LANG_JP) {
          if (!this.localFirstName) {
            this.errors.localFirstName = this.$t('required_display')
            if (!flag) {
              this.$refs.localFirstName.focus()
            }
            flag = true
          } else {
            this.errors.localFirstName = false
          }

          if (this.$i18n.locale == this.$const.LANG_JP) {
            if (!this.localLastName) {
              this.errors.localLastName = this.$t('required_display')
              if (!flag) {
                this.$refs.localLastName.focus()
              }
              flag = true
            } else {
              this.errors.localLastName = false
            }
          }
        }

        if (!this.emailAddress) {
          this.errors.emailAddress = this.$t('required_display')
          if (!flag) {
            this.$refs.emailAddress.focus()
          }
          flag = true
        } else if (!this.validEmail(this.emailAddress)) {
          this.errors.emailAddress = this.$t('validate_invalid_email')
          if (!flag) {
            this.$refs.emailAddress.focus()
          }
          flag = true
        } else {
          this.errors.emailAddress = false
        }
        if (!this.phone) {
          this.errors.phone = this.$t('required_display')
          if (!flag) {
            this.$refs.phone.focus()
          }
          flag = true
        } else if (!this.phone.match(/^[0-9]+$/)) {
          this.errors.phone = this.$t('input_phone_reminder')
          if (!flag) {
            this.$refs.phone.focus()
          }
          flag = true
        } else if (this.phone.length < this.$const.PHONE_MIN_LENGTH || this.phone.length > this.$const.PHONE_MAX_LENGTH) {
          this.errors.phone = this.$t('validate_invalid_phone')
          if (!flag) {
            this.$refs.phone.focus()
          }
          flag = true
        } else if (this.checkPhoneValid(this.phone)) {
          this.errors.phone = this.$t('validate_invalid_phone_number')
          if (!flag) {
            this.$refs.phone.focus()
          }
          flag = true
        } else {
          this.errors.phone = false
        }
        if(this.receive_notification) {
          if (this.birthday.day == '' || this.birthday.month == '' || this.birthday.year == '') {
            this.errors.birthday = this.$t('required_display')
            if (this.birthday.day == '') {
              this.errors.birthday_day = true
            }
            if (this.birthday.month == '') {
              this.errors.birthday_month = true
            }
            if (!flag) {
              if (this.birthday.day == '') {
                this.$refs.birthdayDay.focus()
              } else if (this.birthday.month == '') {
                this.$refs.birthdayMonth.focus()
              } else if (this.birthday.year == '') {
                this.$refs.birthdayYear.focus()
              }
            }
            flag = true
          } else if (!this.validBirthday(this.birthday)) {
            this.errors.birthday = this.$t('validate_invalid_birthday')
            if (!flag) {
              this.$refs.birthday.focus()
            }
            flag = true
          }
        }
        if (!this.term) {
          this.errors.term = this.$t('validate_term')
          if (!flag) {
            this.$refs.term.focus()
          }
          flag = true
        }

        if (flag) {
          return false
        }
        this.setDataParams()
      },
      validBirthday: function (day) {
        let d = new Date(day.year, day.month - 1, day.day)
        return d instanceof Date && !isNaN(d) && (d.getMonth() + 1) == day.month
      },
      setDataParams:function () {
        this.params.first_name = this.firstName
        this.params.last_name = this.lastName
        this.params.phone = this.lodash.startsWith(this.phone, '0') ? this.phone : (this.prefix + this.phone)
        this.params.birthday = this.receive_notification ? moment(String(this.birthday.year + '/' + this.birthday.month + '/' + this.birthday.day)).format('YYYY/MM/DD') : '1899/01/01',
        this.params.receive_notification = this.receive_notification
        this.params.pizza_preference = this.pizza_preference
        this.$root.$emit('modalGetInfoUser',this.params)
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
#modals-container > div.v--modal {
  height: 900px;
}
#modalConfirmRegister {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalConfirmRegister.vue